<template>
  <div>
    <v-layout row wrap mt-1>
      <v-flex xs12 md3 px-2 align-self-center>
        <div v-if="imageObj.blobImage">
          <div ref="img">
            <v-img :src="'data:' + imageMimeType + ';base64,' + imageObj.blobImage" @error="pdfLoaded()" aspect-ratio="1">
              <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
              </v-layout>
            </v-img>
          </div>

          <v-tooltip v-if="isEditMode" bottom>
            <v-btn slot="activator" @click="deleteImage" icon>
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Rimuovi locandina</span>
          </v-tooltip>
        </div>
        <div v-else-if="!evt.id">
          <small>
            La locandina potrà essere caricata
            <br />dopo il salvataggio dell' evento
          </small>
        </div>
        <div v-else-if="isEditMode">
          <v-tooltip bottom>
            <v-btn slot="activator" @click="pickFile" fab icon color="secondary">
              <v-icon color="white">add_circle</v-icon>
            </v-btn>
            <span>Carica Locandina</span>
          </v-tooltip>
          <input ref="image" @change="onFilePicked" type="file" accept="application/pdf" style="display: none;" />
        </div>
      </v-flex>
      <v-flex xs12 md9>
        <v-layout row wrap>
          <v-flex v-if="evt.TipologiaEvento === 'Gara' || evt.TipologiaEvento === 'Didattico'" xs12 md4>
            <v-autocomplete
              v-model="evt.Associazione"
              :items="associazioni"
              :label="isEditMode ? 'Sodalizio *' : 'Sodalizio'"
              :box="isEditModeAdmin"
              :class="{ 'readonly-field': !isEditModeAdmin }"
              :clearable="isEditModeAdmin"
              :readonly="!isEditModeAdmin"
              item-text="Denominazione"
              return-object
              hide-details
            ></v-autocomplete>
          </v-flex>
          <v-flex v-else xs12 md4>
            <v-text-field
              v-model="Organizzazione"
              :label="isEditMode ? 'Organizzazione *' : 'Organizzazione'"
              :box="isEditMode"
              :class="{ 'readonly-field': !isEditMode }"
              hide-details
              required
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md2>
            <v-menu v-model="DataEventoMenu" :close-on-content-click="false" box lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
              <v-text-field
                slot="activator"
                v-model="DataEventoStr"
                :label="isEditMode ? 'Data Evento *' : 'Data Evento'"
                :box="isEditMode"
                :class="{ 'readonly-field': !isEditMode }"
                :clearable="isEditMode"
                :readonly="!isEditMode"
                @blur="evt.DataEvento = Util.parseDate(DataEventoStr)"
                hide-details
                hint="DD/MM/YYYY format"
                append-icon="event"
                required
              ></v-text-field>
              <v-date-picker v-if="isEditMode" v-model="evt.DataEvento" @input="DataEventoMenu = false" first-day-of-week="1" locale="it-IT" no-title></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 md2>
            <v-menu v-model="DataAperturaMenu" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
              <v-text-field
                slot="activator"
                v-model="DataAperturaStr"
                :label="isEditMode ? 'Data Apertura *' : 'Data Apertura'"
                :box="isEditMode"
                :class="{ 'readonly-field': !isEditMode }"
                :clearable="isEditMode"
                :readonly="!isEditMode"
                @blur="evt.DataApertura = Util.parseDate(DataAperturaStr)"
                hide-details
                hint="DD/MM/YYYY format"
                persistent-hint
                append-icon="event"
                required
              ></v-text-field>
              <v-date-picker v-if="isEditMode" v-model="evt.DataApertura" @input="DataAperturaMenu = false" first-day-of-week="1" locale="it-IT" no-title></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 md2>
            <v-menu v-model="DataChiusuraMenu" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
              <v-text-field
                slot="activator"
                v-model="DataChiusuraStr"
                :box="isEditMode"
                :class="{ 'readonly-field': !isEditMode }"
                :clearable="isEditMode"
                :readonly="!isEditMode"
                @blur="evt.DataChiusura = Util.parseDate(DataChiusuraStr)"
                label="Data Chiusura"
                hide-details
                hint="DD/MM/YYYY format"
                persistent-hint
                append-icon="event"
              ></v-text-field>
              <v-date-picker v-if="isEditMode" v-model="evt.DataChiusura" @input="DataChiusuraMenu = false" first-day-of-week="1" locale="it-IT" no-title></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 md2>
            <v-layout v-if="visualizzaSwitch" column justify-center align-center>
              <h5 class="text-uppercase primary--text">Attivo</h5>
              <v-switch v-model="evt.isAttivo" :label="`${evt.isAttivo ? 'SI' : 'NO'}`" class="mt-0" hide-details></v-switch>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-layout column wrap>
              <v-flex xs6 md3>
                <v-autocomplete
                  v-model="evt.AnnoSportivo"
                  :items="insertMode ? anniSportiviValidi : anniSportivi"
                  :label="evt.TipologiaEvento === 'Gara' ? (isEditMode ? 'Anno Sportivo *' : 'Anno Sportivo') : 'Anno'"
                  :box="isEditMode"
                  :class="{ 'readonly-field': !isEditMode }"
                  :readonly="!isEditMode"
                  item-text="Descrizione"
                  return-object
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex v-if="evt.TipologiaEvento === 'Gara'" xs6 md3>
                <v-autocomplete
                  v-model="evt.TipoEvento"
                  :items="tipiEventoFiltrati"
                  :label="isEditMode ? 'Tipo Evento *' : 'Tipo Evento'"
                  :box="isEditMode"
                  :class="{ 'readonly-field': !isEditMode }"
                  :clearable="isEditMode"
                  :readonly="!isEditMode"
                  item-text="Descrizione"
                  return-object
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex v-else xs6 md3>
                <v-text-field
                  v-model="evt.TipologiaEvento"
                  :label="isEditMode ? 'Tipo Evento *' : 'Tipo Evento'"
                  :box="isEditMode"
                  :class="{ 'readonly-field': !isEditMode }"
                  hide-details
                  required
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex v-if="evt.TipologiaEvento === 'Gara' && !garaIbo" xs6 md3>
                <v-autocomplete
                  v-model="evt.ClassificazioneEvento"
                  :items="classificazioneEvento"
                  :label="isEditMode ? 'Classificazione *' : 'Classificazione'"
                  :box="isEditMode"
                  :class="{ 'readonly-field': !isEditMode }"
                  :clearable="isEditMode"
                  :readonly="!isEditMode"
                  return-object
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 md3>
                <v-text-field
                  v-model="evt.eventoConi"
                  :label="isEditMode ? 'Codice C.O.N.I. *' : 'Codice C.O.N.I.'"
                  :box="isEditMode"
                  :class="{ 'readonly-field': !isEditMode }"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-layout row wrap mt-0>
                  <v-flex v-if="evt.TipologiaEvento === 'Gara' && !garaIbo" xs3 md3>
                    <v-layout column justify-center align-left>
                      <h5 style="text-align: initial;" class="text-uppercase primary--text">Indoor</h5>
                      <v-switch v-model="isIndoor" :label="`${isIndoor ? 'SI' : 'NO'}`" class="mt-0 mb-0" hide-details readonly></v-switch>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="evt.TipologiaEvento === 'Gara' && !garaIbo" xs4 md4>
                    <v-layout column justify-center align-left>
                      <h5 style="text-align: initial;" class="text-uppercase primary--text">Open</h5>
                      <v-switch v-model="evt.isOpen" :label="`${evt.isOpen ? 'SI' : 'NO'}`" :readonly="!isEditMode" class="mt-0 mb-0" hide-details></v-switch>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="isAdmin || (isResponsabile && isSameAssociazione)" xs5 md5>
                    <v-autocomplete
                      v-model="evt.StatoEvento"
                      :items="statiEvento"
                      :label="isEditMode ? 'Stato *' : 'Stato'"
                      :box="isEditMode"
                      :class="{ 'readonly-field': !isEditMode }"
                      :clearable="isEditMode"
                      :readonly="!isEditMode"
                      return-object
                      hide-details
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md8>
            <v-layout column wrap>
              <v-flex v-if="evt.TipologiaEvento != 'Gara'" xs12 md3>
                <v-autocomplete
                  v-model="evt.TitoloEvento"
                  :items="evt.TipologiaEvento === 'Didattico' ? listaTitoliDidattici : listaTitoliFormativi"
                  :label="isEditMode ? 'Titolo Evento *' : 'Titolo Evento'"
                  :box="isEditMode"
                  :class="{ 'readonly-field': !isEditMode }"
                  :clearable="isEditMode"
                  :readonly="!isEditMode"
                  hide-details
                  required
                  item-text="Descrizione"
                  item-value="Descrizione"
                ></v-autocomplete>
              </v-flex>
              <v-flex v-else xs12 md3>
                <v-text-field
                  v-model="evt.TitoloEvento"
                  :label="isEditMode ? 'Titolo Evento *' : 'Titolo Evento'"
                  :box="isEditMode"
                  :class="{ 'readonly-field': !isEditMode }"
                  :clearable="isEditMode"
                  :readonly="!isEditMode"
                  hide-details
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-textarea
                  v-model="evt.DescrizioneEvento"
                  :label="isEditMode ? 'Descrizione Evento *' : 'Descrizione Evento'"
                  :box="isEditMode"
                  :class="{ 'readonly-field': !isEditMode }"
                  :clearable="isEditMode"
                  :readonly="!isEditMode"
                  height="188px"
                  hide-details
                  required
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              v-model="emailDefault"
              v-validate="'email'"
              :label="isEditMode ? 'Email di riferimento *' : 'Email di riferimento'"
              :box="isEditMode"
              :class="{ 'readonly-field': !isEditMode }"
              :clearable="isEditMode"
              :readonly="!isEditMode"
              @change="emailDefaultChange"
              name="emailRiferimento"
              data-vv-as="EmailRiferimento"
              hide-details
              required
            ></v-text-field>
            <span class="errMsg">{{ errors.first('emailRiferimento') }}</span>
          </v-flex>
          <v-flex xs6 md3>
            <v-text-field
              v-model="evt.Telefono"
              :box="isEditMode"
              :class="{ 'readonly-field': !isEditMode }"
              :clearable="isEditMode"
              :readonly="!isEditMode"
              hide-details
              name="telefono"
              data-vv-as="Telefono"
              label="Telefono"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md3>
            <v-text-field
              v-model="evt.Cellulare"
              :box="isEditMode"
              :class="{ 'readonly-field': !isEditMode }"
              :clearable="isEditMode"
              :readonly="!isEditMode"
              label="Cellulare"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs4 md2>
            <v-text-field
              v-model="numeroPostiTotali"
              :box="isEditMode"
              :readonly="!isEditMode"
              :clearable="isEditMode"
              :class="{ 'readonly-field': !isEditMode }"
              label="Posti"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12 mt-3 class="text-xs-left">
            <h5 class="text-uppercase primary--text">INDIRIZZO</h5>
          </v-flex>
          <v-flex xs12>
            <campi-indirizzo :indirizzo="evt.IndirizzoEvento" :tipo="'corrispondenza'" :hide-label="true" :form-mode.sync="propFormMode" :show-required="true"></campi-indirizzo>
          </v-flex>

          <v-flex xs12 md12 mt-3 class="text-xs-left">
            <h5 class="text-uppercase primary--text">Coordinate GPS</h5>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="evt.CoordinateGPS"
              :box="isEditMode"
              :class="{ 'readonly-field': !isEditMode }"
              :clearable="isEditMode"
              :readonly="!isEditMode"
              label="GPS"
              hide-details
            ></v-text-field>
          </v-flex>

          <v-flex v-if="evt.TipologiaEvento === 'Gara' && isEditMode" xs12 md12 mt-3 class="text-xs-left">
            <v-autocomplete
              v-model="evt.Giudice"
              :items="giudici"
              :label="isAdmin ? 'Giudice di Gara*' : 'Giudice di Gara'"
              :box="isEditMode"
              :class="{ 'readonly-field': !isEditMode }"
              :clearable="isEditMode"
              :readonly="!isEditMode || isResponsabile"
              item-text="Denominazione"
              hide-details
            >
              <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span v-if="data.item.NumeroTessera" class="text-xs-left font-weight-bold">{{ data.item.NumeroTessera }} -</span>
                      {{ data.item.Denominazione }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>

          <v-flex v-if="evt.TipologiaEvento != 'Gara'" xs12 md12 mt-3 class="text-xs-left">
            <h5 class="text-uppercase primary--text">Docenti/Istruttori</h5>
          </v-flex>
          <v-flex v-if="evt.TipologiaEvento != 'Gara'" xs12>
            <v-textarea
              v-model="evt.Istruttore"
              :box="isEditMode"
              :class="{ 'readonly-field': !isEditMode }"
              :clearable="isEditMode"
              :readonly="!isEditMode"
              label="Docenti/Istruttori"
              hide-details
            ></v-textarea>
          </v-flex>

          <v-flex v-if="evt.TipologiaEvento === 'Gara' && isEditMode" xs4 md2 mt-3>
            <v-layout column align-left>
              <h5 class="text-uppercase primary--text" style="text-align: initial;">Invio medaglie/score</h5>
              <v-switch v-model="evt.InvioScore" :label="`${evt.InvioScore ? 'SI' : 'NO'}`" :readonly="!isEditMode || isResponsabile" class="mt-0 mb-0" hide-details></v-switch>
            </v-layout>
          </v-flex>

          <v-flex v-if="evt.InvioScore && evt.TipologiaEvento === 'Gara'" xs8 md2 mt-3>
            <v-menu v-model="DataScoreMenu" :close-on-content-click="false" box lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
              <v-text-field
                slot="activator"
                v-model="DataScoreStr"
                :box="isEditMode"
                :class="{ 'readonly-field': !isEditMode }"
                :clearable="isEditMode"
                :readonly="!isEditMode"
                @blur="DataScoreStr = Util.parseDate(DataScoreStr)"
                label="Data invio medaglie/score"
                hint="DD/MM/YYYY format"
                hide-details
                append-icon="event"
                required
              ></v-text-field>
              <v-date-picker v-if="isEditMode" v-model="evt.DataInvioScore" @input="DataScoreMenu = false" first-day-of-week="1" locale="it-IT" no-title></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-flex v-if="(isResponsabile || isAdmin) && evt.id" xs12 md3 px-2 align-self-left>
      <div>
        <v-btn slot="activator" @click="dialogNotificheOpen" dark color="primary">
          <v-icon dark color="white" left>email</v-icon>
          invia email ai sodalizi
        </v-btn>
      </div>
    </v-flex>

    <v-dialog v-model="dialogNotifiche" max-width="700">
      <v-card>
        <v-card-title class="display-1 font-weight-bold primary white--text">Invia pubblicazione evento</v-card-title>
        <v-card-text class="headline">Inviare la mail di notifica a tutti i responsabili dei sodalizi?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogNotifiche = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="inviaNotificaPubblicazione(evt)" color="primary white--text" dark> <v-icon small class="mr-1" left>send</v-icon> Invia </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import { bus } from '@/main';
  import EventoEntity from './EventoEntity';
  import CampiIndirizzo from '@/pages/anagrafica/generale/CampiIndirizzo';
  import Util from '@/util';
  import Security from '@/security';
  import ImageEntity from '@/pages/anagrafica/generale/ImageEntity';
  import TipologiaGare from '@/api/tipologiaGare.js';
  import { enTipologiaEvento, enCodiciTipoEventoAdmin } from '@/api/enums';

  export default {
    components: { CampiIndirizzo },
    props: ['propImage', 'evt', 'image', 'propFormMode', 'emailDefault'],
    data() {
      return {
        Util,
        formModes: Util.enFormMode,
        enTipologia: enTipologiaEvento,
        enCodiciTipoEvento: enCodiciTipoEventoAdmin,
        ruoli: Security.ruolo,
        elencoFunzioni: Security.enFunzione,
        eventoDialog: false,
        emailNull: '',
        dialogNotifiche: false,
        valid: false,
        imageObj: new ImageEntity(),
        eventoObj: new EventoEntity(),
        imageMimeType: null,
        Organizzazione: 'C.S.A.In. Comitato Provinciale Cremona',
        classificazioneEvento: ['Provinciale', 'Regionale', 'Nazionale', 'Internazionale', 'Amichevole'],
        statiEvento: ['Inserito', 'Aperto', 'Chiuso'],
        tipologiaGare: TipologiaGare,
        DataEventoStr: new Date().toISOString().substr(0, 10),
        DataAperturaStr: new Date().toISOString().substr(0, 10),
        DataChiusuraStr: new Date().toISOString().substr(0, 10),
        DataScoreStr: Util.formattaData(new Date().toISOString().substr(0, 10)),
        DataEventoMenu: false,
        DataAperturaMenu: false,
        DataChiusuraMenu: false,
        DataScoreMenu: false,
      };
    },
    computed: {
      ...mapGetters('associazioniModule', ['getAssociazioni']),
      ...mapGetters('sharedModule', [
        'getTipiEvento',
        'getSezioni',
        'getTipiAssocizione',
        'getTipiAssicurazione',
        'getTipiTessera',
        'getAnniSportivi',
        'getAnniSportiviValidi',
        'getTitoliEventoFormativo',
        'getTitoliEventoDidattico',
        'getCategorieEventoIBO',
      ]),
      ...mapGetters(['isLogged', 'jwt']),
      ...mapGetters(['userData']),
      ...mapGetters('associatiModule', ['getGiudici']),

      garaIbo() {
        if (this.evt.TipoEvento.Codice != 'IBO_INDOOR' && this.evt.TipoEvento.Codice != 'IBO_OUTDOOR') {
          return false;
        } else {
          return true;
        }
      },

      isIndoor: {
        get() {
          let tipoEventoSelected = this.evt.TipoEvento;
          if (tipoEventoSelected != undefined) {
            const tipoGara = this.tipologiaGare.find((e) => {
              return e.Codice == this.evt.TipoEvento.Codice;
            });
            if (tipoGara) {
              this.evt.isIndoor = tipoGara.Indoor;
              return tipoGara.Indoor;
            }
          }
          return '';
        },
        set(newValue) {
          this.evt.isIndoor = newValue;
        },
      },

      numeroPostiTotali: {
        get() {
          if (this.evt.id == null){
          let tipoEventoSelected = this.evt.TipoEvento;

          if (tipoEventoSelected != undefined) {
            const tipoGara = this.tipologiaGare.find((e) => {
              return e.Codice == this.evt.TipoEvento.Codice;
            });
            if (tipoGara) {
              this.evt.NumeroPostiTotali = tipoGara.NumeroPosti;
              return tipoGara.NumeroPosti;
            }
          }
          return '';
        } else {
          return this.evt.NumeroPostiTotali;
        }
        },
        set(newValue) {
          this.evt.NumeroPostiTotali = newValue;
        },
      },
      associazioni() {
        return this.getAssociazioni;
      },
      giudici() {
        return this.getGiudici;
      },
      tipiEvento() {
        return this.getTipiEvento;
      },
      anniSportivi() {
        return this.getAnniSportivi;
      },
      anniSportiviValidi() {
        return this.getAnniSportiviValidi;
      },
      listaTitoliFormativi() {
        return this.getTitoliEventoFormativo;
      },
      listaTitoliDidattici() {
        return this.getTitoliEventoDidattico;
      },
      listaTitoliIBO() {
        return this.getCategorieEventoIBO;
      },
      visualizzaSwitch() {
        if (this.evt.TipologiaEvento != null) {
          if (this.isAdmin) {
            return true;
          } else if (this.isResponsabile && this.evt.TipologiaEvento.toUpperCase() === this.enTipologia.DIDATTICO) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      isEventoDidattico() {
        if (this.evt.TipologiaEvento != null) {
          if (this.evt.TipologiaEvento.toUpperCase() === this.enTipologia.DIDATTICO) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      isEventoFormativo() {
        if (this.evt.TipologiaEvento != null) {
          if (this.evt.TipologiaEvento.toUpperCase() === this.enTipologia.FORMAZIONE) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      tipiEventoFiltrati() {
        let tipoEventiFiltrati = [];
        if (this.isEventoDidattico || this.isEventoFormativo) {
          tipoEventiFiltrati = this.tipiEvento.filter((t) => t.Codice === 'FOR' || t.Codice === 'DIDA');
        } else {
          tipoEventiFiltrati = this.tipiEvento.filter((t) => t.Codice != 'DIDA' && t.Codice != 'FOR' && t.Codice != 'ST_HISTORY_EU');
          /* eventi per gara*/
          if (this.insertMode || this.modifyMode) {
            if (this.userData.Role != this.ruoli.UTENTE_AMMINISTRATIVO && this.userData.Role != this.ruoli.ADMIN) {
              /* eventi per utente standard */
              tipoEventiFiltrati = tipoEventiFiltrati.filter(
                (t) =>
                  t.Codice != this.enCodiciTipoEvento.CI_OUTDOOR &&
                  t.Codice != this.enCodiciTipoEvento.CI_INDOOR &&
                  t.Codice != this.enCodiciTipoEvento.CI_REGIONI &&
                  t.Codice != this.enCodiciTipoEvento.IBO_INDOOR &&
                  t.Codice != this.enCodiciTipoEvento.IBO_OUTDOOR &&
                  t.Codice != this.enCodiciTipoEvento.CI_IBO_INDOOR &&
                  t.Codice != this.enCodiciTipoEvento.CI_IBO_OUTDOOR &&
                  t.Codice != this.enCodiciTipoEvento.ST_HISTORY_EU,
              );
            }
          }
        }
        return tipoEventiFiltrati;
      },

      insertMode() {
        return this.propFormMode === this.formModes.INSERIMENTO;
      },
      modifyMode() {
        return this.propFormMode === this.formModes.MODIFICA;
      },
      viewMode() {
        return this.propFormMode === this.formModes.VISUALIZZAZIONE;
      },
      emailNullDefault() {
        if (this.isAdmin && this.insertMode && this.evt.TipologiaEvento === 'Gara') {
          return (this.emailDefault = this.emailNull);
        } else return this.emailDefault;
      },
      isAdmin() {
        if (this.userData.Role) {
          return (
            ((this.propFormMode === this.formModes.INSERIMENTO || this.propFormMode === this.formModes.MODIFICA) && this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO) ||
            this.userData.Role === this.ruoli.ADMIN
          );
        } else {
          return false;
        }
      },
      isResponsabile() {
        if (this.userData.Role === this.ruoli.RESPONSABILE_ASSOCIAZIONE) {
          return true;
        } else {
          return false;
        }
      },
      isSameAssociazione() {
        if (this.evt.Associazione.id != null) {
          if (this.evt.Associazione.id.toString() === this.userData.AssociazioneId) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },

      isEditModeAdmin() {
        let retVal = false;
        if (this.userData.Role) {
          if (this.propFormMode === this.formModes.MODIFICA || this.propFormMode === this.formModes.INSERIMENTO) {
            if (this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN) {
              retVal = true;
            }
          }
        }
        return retVal;
      },
      isEditMode() {
        let retVal = false;
        if (this.userData.Role) {
          if (this.propFormMode === this.formModes.MODIFICA || this.propFormMode === this.formModes.INSERIMENTO) {
            if (this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN) {
              retVal = true;
            }
            if (this.userData.Role === this.ruoli.RESPONSABILE_ASSOCIAZIONE && this.checkFunzione(this.elencoFunzioni.INSERIMENTO_ASSOCIATO_ASSOCIAZIONE)) {
              retVal = true;
            }
          }
        }
        return retVal;
      },
    },
    watch: {
      $props: {
        handler() {
          // date formattate da visualizzare nei campi del form
          this.DataEventoStr = this.evt.DataEvento ? Util.formattaData(new Date(this.evt.DataEvento).toISOString().substr(0, 10)) : null;
          this.DataAperturaStr = this.evt.DataApertura ? Util.formattaData(new Date(this.evt.DataApertura).toISOString().substr(0, 10)) : null;
          this.DataChiusuraStr = this.evt.DataChiusura ? Util.formattaData(new Date(this.evt.DataChiusura).toISOString().substr(0, 10)) : null;
          this.DataScoreStr = this.evt.DataInvioScore ? Util.formattaData(new Date(this.evt.DataInvioScore).toISOString().substr(0, 10)) : null;
        },
        deep: true,
        immediate: true,
      },
      image() {
        this.imageObj = new ImageEntity(this.image);
        this.imageMimeType = Util.guessImageMime(this.image);
      },
    },
    created() {
      this.loadTipologie();
      this.loadAssociazioni();
      this.loadGiudici();
      const vm = this;
      bus.$on('eventoDialog', function (value) {
        vm.eventoDialog = value;
      });
    },
    methods: {
      ...mapActions('associazioniModule', ['loadAssociazioni']),
      ...mapActions('eventiModule', ['loadEvento', 'updateLocandina', 'inviaNotificaPubblicazioneEvento']),
      ...mapActions('associatiModule', ['loadGiudici']),
      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      ...mapActions('sharedModule', ['loadTipologie']),
      pdfLoaded() {
        this.$refs.img.innerHTML = '<i class="fa fa-3x fa-file-pdf-o red--text mb-2"></i><h5>PDF CARICATO<br>CON SUCCESSO</h5>';
      },
      deleteImage() {
        this.imageObj = new ImageEntity();
      },
      pickFile() {
        this.$refs.image.click();
      },
      onFilePicked(e) {
        const vm = this;
        const files = e.target.files;
        if (files[0] !== undefined) {
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener('load', () => {
            vm.imageObj = new ImageEntity();
            vm.imageObj.blobImage = fr.result.replace('data:' + files[0].type + ';base64,', '');
            let uploadData = new FormData();
            uploadData.append('id', vm.evt.id);
            uploadData.append('invito', files[0], files[0].name);
            vm.updateLocandina({ id: vm.evt.id, uploadData: uploadData });
          });
        } else {
          vm.imageObj = new ImageEntity();
        }
      },
      emailDefaultChange() {
        const vm = this;
        bus.$emit('emailDefaultChange', vm.emailDefault);
      },
      dialogNotificheOpen() {
        this.dialogNotifiche = true;
      },
      inviaNotificaPubblicazione(t) {
        this.inviaNotificaPubblicazioneEvento({eventoId:t.id, annoSportivoId: t.AnnoSportivoId});
        this.dialogNotifiche = false;
      },
    },
  };
</script>
<style>
  .v-input__icon--append .fa-asterisk {
    font-size: 1rem;
  }
</style>
